<template>
  <div class="xcard">
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras
    </v-btn>

    <template>
      <v-data-table :headers="headers" :items="desserts" :loading="loading" sort-by="calories" class="elevation-1">
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>
              <span>Planes de pagos predefinidos.</span>
            </v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-btn class="green darken-2 white--text" @click="openregistrar()">
              <v-icon small class="mr-2">
                mdi-pencil
              </v-icon>
              Agregar
            </v-btn>
          </v-toolbar>
        </template>
        
        <template v-slot:[`item.estado`]="{ item }">

          <v-chip :color="item.estado == null ? 'grey' : item.estado ? 'green' : 'red'" dark>
            {{ item.estado?'Activo': 'Inactivo' }}
          </v-chip>

        </template>

        <template v-slot:[`item.conceptos`]="{ item }">
          <p class="my-0" v-for="(c, ind) in item.conceptos" :key="ind">[{{ c.max_cuotas }}] {{ c.nombre }}</p>
        </template>

        <template v-slot:[`item.opciones`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="mr-4" color="green" v-bind="attrs" v-on="on" @click="veritem(item)">
                mdi-eye
              </v-icon>
            </template>
            <span> Ver detalles </span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="mr-4" color="orange" v-bind="attrs" v-on="on" @click="moditem(item)">
                mdi-pencil
              </v-icon>
            </template>
            <span> Editar plan </span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="mr-0" color="red" v-bind="attrs" v-on="on" @click="prerevertir(item)">
                mdi-close
              </v-icon>
            </template>
            <span> Eliminar </span>
          </v-tooltip>
        </template>
      </v-data-table>
    </template>

    <Registrar ref="registrarref" v-on:onreg="onreg" />
    <Modificar ref="modificarref" v-on:onreg="onreg" />
    <Ver ref="verref" />
  </div>
</template>

<script>
import xaxios from '@/xaxios';
import Registrar from '@/views/programas/plan-template-add.vue';
import Modificar from '@/views/programas/plan-template-mod.vue';
import Ver from '@/views/programas/plan-template-view.vue';
export default {
  data: () => ({
    loading: false,
    programa_name: '',

    headers: [
      { text: 'Nro', value: 'nro', width: 20 },
      { text: 'Nombre', value: 'nombre' },
      { text: 'Unidad negocio ID', value: 'unidad_negocio_id' },
      { text: 'Estado', value: 'estado' },
      { text: 'Conceptos', value: 'conceptos' },
      { text: 'Opciones', value: 'opciones', sortable: false, width: 140 },
    ],
    desserts: [],
  }),
  components: { Registrar, Ver, Modificar },
  computed: {},
  watch: {
    '$store.state.CARGO.sede': function () {
      this.listar();
    },
  },
  methods: {
    openregistrar() {
      this.$refs.registrarref.openmodal();
    },
    listar() {
      this.loading = true;
      this.desserts = [];
      let unidad = this.$store.state.CARGO.sede.unidad_negocio;
      window.console.log(this.$store.state.CARGO);
      let vue = this;
      var config = {
        method: 'get',
        url: `${process.env.VUE_APP_API_REST}/api/v1/esam/templates/planpagos?unidadnegocio=${unidad}`,
        headers: {},
      };

      xaxios.request(config)
        .then(function (response) {
          let data = response.data.data;
          data = data.reverse();
          data.map((x, i) => {
            x.nro = i + 1;
          });
          window.console.log(data);
          vue.desserts = data;
          vue.loading = false;
        })
        .catch(function (error) {
          window.console.log(error);
          vue.loading = false;
        });
    },
    onreg() {
      this.listar();
    },
    veritem(item) {
      this.$refs.verref.openmodal(item);
    },
    moditem(item) {
      this.$refs.modificarref.openmodal(item);
    },
    async prerevertir(item) {
      let message = {
        title: `confirmacion necesaria:`,
        body: '',
      };
      var opt = {
        verification: 'eliminar',
        verificationHelp: 'Escriba "[+:verification]" para proceder.',
        okText: 'Proceder',
        cancelText: 'cancelar',
        backdropClose: false,
        animation: 'bounce',
        loader: true,
        type: 'hard',
      };
      let dialogo = await this.$dialog
        .confirm(message, opt)
        .then((dialog) => dialog)
        .catch(() => { });
      if (!dialogo) return;

      var config = {
        method: 'delete',
        url: `${process.env.VUE_APP_API_REST}/api/v1/esam/templates/planpagos/${item.id}`,
        headers: {
          'Content-Type': 'application/json',
        },
      };

      xaxios.request(config)
        .then(({ data }) => {
          window.console.log(data);
          this.listar();
          dialogo.close();
        })
        .catch((e) => {
          window.console.log(e);
          dialogo.close();
        });
    },
  },
  mounted() {
    this.listar();
  },
};
</script>
